<template>
    <PDFView 
    v-if="pdfSource"
    :source="pdfSource" 
    :page="-1" 
    @loaded="onPdfLoaded" 
    />
    
    <v-sheet 
    height="80vh" max-height="80vh" 
    class="pl-2 pr-2 w-auto overflow-y-auto hidden-scrollbar
         d-flex flex-column 
         bg-blue-grey-lighten-5"
         style="min-height:0;" 
    >
    <p class="pt-10n ma-16n text-h5 text-center bg-blue-grey-lighten-4 "> Original </p>
        <div 
         v-for="page in totalPages" 
         :key="page" 
         class="mb-0"
         style="position: relative;"  
         >   
            
            <p class="pt-0 text-left text-h6 font-weight-light">{{ page }}
                <v-icon
                    v-if="frames && frames[page - 1]?.isReplaced"
                    color="red lighten-1"
                    size="small"
                    class="ml-16 center"
                    
                >
                   mdi-star
                </v-icon>

                <v-icon
                v-if="frames && frames[page - 1]?.isGenerated"
                color="green lighten-1"
                size="small"
                :class="['text-left', frames[page - 1]?.isReplaced ? 'ml-0' : 'ml-16']"
                >
                  mdi-lightbulb-on-outline
                </v-icon>
            </p>


            
            <div 
                v-if="frames" 
                class="absolute"
                >
                <v-card 
                    v-if="frames[page - 1]?.isReplaced"

                    class="pa-2"
                    style="position: absolute; top: -5; right: 0; width: 80px; z-index: 10;"
                    elevation="5"
                    v-motion-slide-top
                    
                >
                    <PDFView 
                    clearable 
                    :source="frames[page-1]?.template?.pdfSource" 
                    :page="frames[page-1]?.selectedSlideTemplate?.pageNumber"
                    />
                </v-card>
            </div>
            <PDFView 
            class="elevation-5 h-auto w-auto " 
            :source="pdfSource" 
            :page="page" 
            :scale="1.5"
            :style="{
                cursor: 'pointer',
            }" 
            cover 
            @click="newSelectedFrame(page)" />
        </div>
    </v-sheet>

</template>

<script lang="ts">
import { Frame } from '@/types/frame';
import { defineComponent } from 'vue';
import PDFView from 'vue-pdf-embed';
export default defineComponent({
    name: 'SlidesOriginalPreview-Componenten',

    props: {
        pdfSource: String,
        frames: Array as () => Frame[] | null,
        
    },
    components: {
        PDFView
    },
    data() {
        return {
            pdfUrl: '' as string,
            pageNumber: 1 as number, 
            numPages: 0 as number, 
            totalPages: 0 as number,
        };
    },
    methods: {
        newSelectedFrame(page: number): void {
            this.$emit("newSelectedFrame", page );
        },
        onPdfLoaded(pdf: any) {
            this.totalPages = pdf.numPages;
        },
    },
});
</script>

<style scoped>
.photo-item {
    margin-bottom: 20px;
}

img {
    max-width: 100%;
    height: auto;
}

.hidden-scrollbar {
    /* Versteckt die Scrollbar */
    scrollbar-width: none;
    /* Für Firefox */
}

.hidden-scrollbar::-webkit-scrollbar {
    /* Für Chrome, Safari und Opera */
    display: none;
}
</style>